import React, { useState } from 'react';
import { InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { profilesApi } from '../../api';
import HrnbButton from '../controls/HrnbButton';
import HrnbSelect from '../controls/HrnbSelect';
import { SaveIcon } from '../../icons';
import HrnbFormControl from '../controls/HrnbFormControl';
import HrnbLabel from '../controls/HrnbLabel';
import HrnbCard from '../controls/HrnbCard';
import { HrnbListGroup, HrnbListGroupItem } from '../controls/HrnbListGroup';

const PROFILE_TYPE_OPTIONS = [
    { value: '', label: 'Не указан' },
    { value: 'rapper', label: 'Рэп-исполнитель' },
    { value: 'beatmaker', label: 'Битмейкер' },
    { value: 'artist', label: 'Художник' },
    { value: 'blogger', label: 'Блогер' },
];

export default function ProfileCard({ profile }) {
    const [editedProfile, setEditedProfile] = useState({
        displayName: profile?.displayName || '',
        bio: profile?.bio || '',
        profileType: profile?.profileType || '',
        city: profile?.city || '',
        country: profile?.country || '',
        socialLinks: Array.isArray(profile?.socialLinks) ? profile.socialLinks : []
    });
    const [saving, setSaving] = useState(false);

    const handleSaveChanges = async () => {
        setSaving(true);
        const requestBody = {
            displayName: editedProfile.displayName,
            bio: editedProfile.bio,
            profileType: editedProfile.profileType || '',
            city: editedProfile.city || null,
            country: editedProfile.country || null,
            socialLinks: Array.isArray(editedProfile.socialLinks)
                ? editedProfile.socialLinks
                : String(editedProfile.socialLinks).split(',').map(s => s.trim()).filter(Boolean)
        };
        try {
            const updated = await profilesApi.update(profile.id, requestBody);
            setEditedProfile({
                displayName: updated.displayName || requestBody.displayName,
                bio: updated.bio || requestBody.bio,
                profileType: updated.profileType || requestBody.profileType || '',
                city: updated.city || requestBody.city || '',
                country: updated.country || requestBody.country || '',
                socialLinks: Array.isArray(updated.socialLinks) ? updated.socialLinks : requestBody.socialLinks
            });
        } catch (err) {
            console.error(err);
        } finally {
            setSaving(false);
        }
    };

    return (
        <HrnbCard title="Публичный профиль">
            <HrnbListGroup variant="flush">
                <HrnbListGroupItem>
                    <InputGroup>
                        <HrnbLabel text="Имя профиля:" required />
                        <HrnbFormControl
                            type="text"
                            value={editedProfile.displayName}
                            onChange={(e) => setEditedProfile(prev => ({ ...prev, displayName: e.target.value }))}
                        />
                    </InputGroup>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <InputGroup>
                        <HrnbLabel text="Тип профиля:" />
                        <HrnbSelect
                            value={editedProfile.profileType}
                            onChange={(val) => setEditedProfile(prev => ({ ...prev, profileType: val }))}
                            options={PROFILE_TYPE_OPTIONS}
                        />
                    </InputGroup>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <InputGroup>
                        <HrnbLabel text="Биография:" required />
                        <HrnbFormControl
                            as="textarea"
                            value={editedProfile.bio}
                            onChange={(e) => setEditedProfile(prev => ({ ...prev, bio: e.target.value }))}
                        />
                    </InputGroup>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <InputGroup>
                        <HrnbLabel text="Город:" />
                        <HrnbFormControl
                            type="text"
                            value={editedProfile.city}
                            onChange={(e) => setEditedProfile(prev => ({ ...prev, city: e.target.value }))}
                        />
                    </InputGroup>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <InputGroup>
                        <HrnbLabel text="Страна:" />
                        <HrnbFormControl
                            type="text"
                            value={editedProfile.country}
                            onChange={(e) => setEditedProfile(prev => ({ ...prev, country: e.target.value }))}
                        />
                    </InputGroup>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <InputGroup>
                        <HrnbLabel text="Социальные сети:" />
                        <HrnbFormControl
                            type="text"
                            value={Array.isArray(editedProfile.socialLinks) ? editedProfile.socialLinks.join(', ') : String(editedProfile.socialLinks)}
                            onChange={(e) => setEditedProfile(prev => ({ ...prev, socialLinks: e.target.value.split(',').map(s => s.trim()).filter(Boolean) }))}
                        />
                    </InputGroup>
                </HrnbListGroupItem>
            </HrnbListGroup>

            <HrnbButton onClick={handleSaveChanges} icon={<SaveIcon />} disabled={saving}>
                {saving ? 'Сохранение...' : 'Сохранить изменения'}
            </HrnbButton>
        </HrnbCard>
    );
}

ProfileCard.propTypes = {
    profile: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        displayName: PropTypes.string,
        bio: PropTypes.string,
        profileType: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        socialLinks: PropTypes.arrayOf(PropTypes.string)
    }).isRequired
};
